import { render, staticRenderFns } from "./Education.vue?vue&type=template&id=3fb8617b&scoped=true&lang=html&"
var script = {}
import style0 from "./Education.vue?vue&type=style&index=0&id=3fb8617b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb8617b",
  null
  
)

export default component.exports